import { Action } from '@ngrx/store';
import { Profile } from '../../services/profile.model';
import { Contact } from '@app/model/contact.model';
import { AuthToken } from '@app/model/auth/auth-token.model';

export const INIT_AUTH = 'AUTH: INIT';
export const EXISTING_LOGIN_FOUND = 'AUTH: EXISTING LOGIN FOUND';
export const SET_AUTH_TOKEN = 'AUTH: SET AUTH TOKEN';
export const AUTH_TOKEN_ERROR = 'AUTH: AUTH TOKEN ERROR';
export const CLEAR_ALL_AUTH_DATA = 'AUTH: CLEAR ALL AUTH DATA';
export const SET_LOGGED_IN = 'AUTH: LOGGED IN';
export const SET_USER_PROFILE = 'AUTH: SET_USER_PROFILE';
export const CLEAR_USER_PROFILE = 'AUTH: CLEAR USER PROFILE';
export const AUTH_TOKEN_VALIDATED = 'AUTH: AUTH TOKEN VALIDATED';
export const LOAD_USER_INFO = 'AUTH: LOAD USER INFO';
export const USER_INFO_LOADED = 'AUTH: USER INFO LOADED';
export const TOKEN_EXPIRED = 'AUTH: TOKEN HAS EXPIRED';
export const CLEAR_ALL_AUTH_DATA_AND_THROW_ERROR = 'AUTH: CLEAR ALL AUTH DATA AND THROW ERROR';
export const SET_LOGIN_ERROR = 'AUTH: SET LOGIN ERROR';
export const CLEAR_LOGIN_ERROR = 'AUTH: CLEAR LOGIN ERROR';
export const EMAIL_VERIFICATION_REQUIRED = 'AUTH: EMAIL VERIFICATION REQUIRED';
export const LOGIN_ATTEMPT = 'AUTH: LOGIN ATTEMPT';

export class InitAuth implements Action {
    readonly type = INIT_AUTH;
}

export class ExistingLoginFound implements Action {
    readonly type = EXISTING_LOGIN_FOUND;

    constructor() { }
}

export class SetAuthToken implements Action {
    readonly type = SET_AUTH_TOKEN;

    constructor(public authToken: AuthToken) { }
}

export class AuthTokenError implements Action {
    readonly type = AUTH_TOKEN_ERROR;

    constructor(public error) { }
}

export class ClearAllAuthDataAndThrowError implements Action {
    readonly type = CLEAR_ALL_AUTH_DATA_AND_THROW_ERROR;

    constructor(error: any) { }
}

export class ClearAllAuthData implements Action {
    readonly type = CLEAR_ALL_AUTH_DATA;

    constructor(public clearCart = false) { }
}

export class SetLoggedIn implements Action {
    readonly type = SET_LOGGED_IN;

    constructor(public loggedIn: boolean, public clearCart = false, public redirect = false) { }
}

export class SetUserProfile implements Action {
    readonly type = SET_USER_PROFILE;

    constructor(public profile: Profile) { }
}

export class ClearUserProfile implements Action {
    readonly type = CLEAR_USER_PROFILE;
}

export class AuthTokenValidated implements Action {
    readonly type = AUTH_TOKEN_VALIDATED;

    constructor(public authToken: AuthToken) { }
}

export class LoadUserInfo implements Action {
    readonly type = LOAD_USER_INFO;

    constructor(public authToken: AuthToken, public initialLoad = false) { }
}

export class UserInfoLoaded implements Action {
    readonly type = USER_INFO_LOADED;

    constructor(public profile: Profile, public contact: Contact, public initialLoad = false) { }
}

export class TokenExpired implements Action {
    readonly type = TOKEN_EXPIRED;

    constructor(public redirectUrl: string = null) {
    }
}

export class SetLoginError implements Action {
    readonly type = SET_LOGIN_ERROR;

    constructor(public error: string = null) {
    }
}

export class ClearLoginError implements Action {
    readonly type = CLEAR_LOGIN_ERROR;
}

export class EmailVerificationRequired implements Action {
    readonly type = EMAIL_VERIFICATION_REQUIRED;

    constructor(public email: string, public isReverification = false) {
    }
}

export class LoginAttempt implements Action {
    readonly type = LOGIN_ATTEMPT;

    constructor(public email: string, public password: string, public isModal: boolean = false) {
    }
}

export type AuthActions = ExistingLoginFound | SetAuthToken | AuthTokenError | ClearAllAuthData | SetLoggedIn |
SetUserProfile | ClearUserProfile | AuthTokenValidated | LoadUserInfo | UserInfoLoaded | TokenExpired |
SetLoginError | ClearLoginError | EmailVerificationRequired | LoginAttempt;
